import { useDocumentTitle, useListenEvents, useUserConnected } from '@/hooks';
import { apiClient } from '@/components/api';
import { useEffect, useState } from 'react';
import { storageService } from '@/services';

interface IState {
  status: 'isLoading' | 'ready' | 'errorApiServerDisconnected';
}

const useAppInitialisation = () => {

  const [state, setState] = useState<IState>({ status: 'isLoading' });
  const { userConnected } = useUserConnected();
  useDocumentTitle({ title: 'Changement...' });

  useListenEvents({
    type: 'apiServerDisconnected',
    callback: () => setState(l => ({ ...l, status: 'errorApiServerDisconnected' }))
  });

  // App start keep only 100 verifications done by user in memory
  useEffect(
    () => {
      storageService
        .recentVerifications
        .keepOnlyFirst(100);
    },
    []
  );

  useEffect(
    () => {
      if (userConnected?.token) {
        apiClient.setHeader('Authorization', `Bearer ${userConnected?.token}`);
      } else {
        apiClient.deleteHeader('Authorization');
      }

      setState(l => ({ ...l, status: 'ready' }));
    },
    [userConnected?.token]
  );

  return ({
    ...state,
    userConnected
  });

};

export default useAppInitialisation;
